export default __webpack_public_path__ + "static/media/waris.d61366e4.jpg";